/**
 * Delays execution for the specified number of milliseconds
 * @param ms Number of milliseconds to delay
 * @returns Promise that resolves after the specified delay
 */
export function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
